import { FunctionComponent } from 'react'
import styles from './DetailsPropInfo.module.scss'
import cn from 'classnames'

type DetailsPropInfoProps = {
  name: string
  value: string
}
export const DetailsPropInfo: FunctionComponent<DetailsPropInfoProps> = ({
  name,
  value,
}) => {
  return (
    <div className={cn(styles.element)}>
      <p className={styles.name}>{name}</p>
      <p className={styles.value}>{value}</p>
    </div>
  )
}
